<div class="form-group">
  <label *ngIf="settings.label" for="exampleFormControlSelect1">{{settings.label}}</label>
  <select [attr.multiple]="settings.multiple ? 'multiple' : null" class="form-control" id="exampleFormControlSelect1">
    <option *ngFor="let option of settings.options">{{option}}</option>
  </select>
</div>